import {createReducer, on} from "@ngrx/store";
import * as actions from "./place-order.action";
import {CartRequestDetails} from "../../../../@domain/cart-request-details";

/**
 * Sorts cart items to show new items (without id) first, then existing items.
 * This ensures a consistent order where unsaved items appear at the top.
 */
function sortCartItems(items: CartRequestDetails[]): CartRequestDetails[] {
  return [...items].sort((a, b) => {
    const aOrderPriority = a.id === undefined ? 0 : 1;
    const bOrderPriority = b.id === undefined ? 0 : 1;
    return aOrderPriority - bOrderPriority;
  });
}


export interface State {
  cartFood: CartRequestDetails;
  cartFoods: CartRequestDetails[];
  isPrinted: boolean;
}

export const initialState: State = {
  cartFood: {} as CartRequestDetails,
  cartFoods: [] as CartRequestDetails[],
  isPrinted: false
}


export const placeOrderReducer = createReducer(
  initialState,
  on(actions.ADD_FOOD_TO_CART, (state, {payload}) => {
    const foodCart = [...state.cartFoods]
    const ifFoodAdded = false
    if (foodCart.length > 0) {
      if (foodCart.some(food =>
        food.foodId === payload.foodId &&
        food.foodQuantityTagId === payload.foodQuantityTagId &&
        food.kitchenIntroduction === payload.kitchenIntroduction &&
        food.id === undefined && food.isServiceCharge === payload.isServiceCharge &&
        (
          (Array.isArray(food.extras) && Array.isArray(payload.extras) &&
            food.extras.length === payload.extras.length &&
            food.extras.every((extra, index) => extra === payload.extras![index])) ||
          (food.extras === null && payload.extras === null)
        )
      )) {
        foodCart.forEach((food, index) => {
          if (
            food.foodId === payload.foodId &&
            food.foodQuantityTagId === payload.foodQuantityTagId&&
            food.kitchenIntroduction === payload.kitchenIntroduction &&
            (
              (Array.isArray(food.extras) && Array.isArray(payload.extras) &&
                food.extras.length === payload.extras.length &&
                food.extras.every((extra, index) => extra === payload.extras![index])) ||
              (food.extras === null && payload.extras === null)
            )
          ) {
            const obj = { ...food };
            obj.quantity += payload.quantity;
            foodCart[index] = obj;
          }
        });
      } else {
        foodCart.push(payload);
      }

    } else {
      foodCart.push(payload)
    }

    return {
      ...state,
      cartFood: payload,
      cartFoods: sortCartItems(foodCart)

    }


  }),

  on(actions.DELETE_FOOD_FORM_CART, (state, { payload }) => {
    const updatedFoodCart = state.cartFoods.filter((food) => {
      if (food.foodId !== payload.foodId) return true;
      if (food.foodQuantityTagId !== payload.foodQuantityTagId) return true;
      if (food.kitchenIntroduction !== payload.kitchenIntroduction) return true;
      if (food.isServiceCharge !== payload.isServiceCharge) return true;

      // Add safeguard for null 'extras'
      if (food.extras !== null && payload.extras !== null) {
        if (food.extras.length !== payload.extras!.length) return true;

        return !food.extras.every((extra, index) => extra === payload.extras![index]);
      }

      // Handle case where one of the extras is null
      if (food.extras === null && payload.extras !== null) return true;
      if (food.extras !== null && payload.extras === null) return true;

      return false;
    });

    return {
      ...state,
      cartFoods: sortCartItems(updatedFoodCart),
    };
  }),

  on(actions.ADD_PRINTED_FOODS_TO_CART, (state, {payload}) => {
    return {
      ...state,
      cartFoods: sortCartItems(payload),
      isPrinted: true
    }
  }),


  on(actions.CLEAR_CART, (state) => {
    return {
      ...state,
      cartFoods: []
    }
  }),

  on(actions.UPDATE_CART_ITEM_NAMES, (state, {payload}) => {
    const updatedCartFoods = state.cartFoods.map(food => ({
      ...food,
      name: food.name || payload.get(food.foodId) || ''
    }));
    return {
      ...state,
      cartFoods: updatedCartFoods
    }
  }),
)


